// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-window {
    margin-top: 80px;
    padding: 20px 12vw 20px 15vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.contact-window h1 {
    color: #fff;
    font-size: 50px;
}

.contact-window p {
    font-size: 16px;
    letter-spacing: 1px;
    word-spacing: 2px;
    margin-bottom: 30px;
}

.contact-container {
    display: flex;
    align-items: flex-end;
    width: 100%;
}

.contact-wrapper-left {
    width: 450px;
    height: 100%;
}

.contact-wrapper-right {
    width: 50%;
    padding-left: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.contact-wrapper-right input, textarea {
    background-color: transparent;
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: 6px;
    margin-bottom: 25px;
    padding-left: 15px;
    font-size: 18px;
    width: 100%;
    transition: 0.3s ease-in-out;
    outline: none;
}

.contact-wrapper-right input {
    height: 45px;
}

.contact-wrapper-right input:focus, textarea:focus {
    border: 1px solid #fff;
    box-shadow: 0 0 10px 2px rgba(255, 255, 255, 0.4);
}

.contact-wrapper-right textarea {
    padding-top: 12px;
}



@media screen and (max-width: 1190px) {
    .contact-wrapper-left {
        max-width: 380px;
        width: 100%;
    }

    .contact-wrapper-right input {
        height: 40px;
        font-size: 16px;
        margin-bottom: 12px;
    }

    .contact-wrapper-right textarea {
        font-size: 16px;
        margin-bottom: 20px;
    }

    .btn#submitBtn {
        margin-top: 0px;
        font-size: 16px;
        font-weight: 400;
    }
}


@media screen and (max-width: 945px), (max-height: 550px) {
    .contact-window {
        padding: 100px 18vw 20px 18vw;
        margin: 0;
    }

    .contact-window h1 {
        font-size: 40px;
    }

    .contact-window p {
        font-size: 14px;
    }

    .contact-wrapper-left {
        display: none;
    }

    .contact-wrapper-right {
        width: 100%;
        padding: 0;
    }

    .contact-wrapper-right form {
        padding-left: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ContactFormStyle.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;AACrB;;;;AAIA;IACI;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;IACpB;AACJ;;;AAGA;IACI;QACI,6BAA6B;QAC7B,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".contact-window {\n    margin-top: 80px;\n    padding: 20px 12vw 20px 15vw;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.contact-window h1 {\n    color: #fff;\n    font-size: 50px;\n}\n\n.contact-window p {\n    font-size: 16px;\n    letter-spacing: 1px;\n    word-spacing: 2px;\n    margin-bottom: 30px;\n}\n\n.contact-container {\n    display: flex;\n    align-items: flex-end;\n    width: 100%;\n}\n\n.contact-wrapper-left {\n    width: 450px;\n    height: 100%;\n}\n\n.contact-wrapper-right {\n    width: 50%;\n    padding-left: 30px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.contact-wrapper-right input, textarea {\n    background-color: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.8);\n    border-radius: 6px;\n    margin-bottom: 25px;\n    padding-left: 15px;\n    font-size: 18px;\n    width: 100%;\n    transition: 0.3s ease-in-out;\n    outline: none;\n}\n\n.contact-wrapper-right input {\n    height: 45px;\n}\n\n.contact-wrapper-right input:focus, textarea:focus {\n    border: 1px solid #fff;\n    box-shadow: 0 0 10px 2px rgba(255, 255, 255, 0.4);\n}\n\n.contact-wrapper-right textarea {\n    padding-top: 12px;\n}\n\n\n\n@media screen and (max-width: 1190px) {\n    .contact-wrapper-left {\n        max-width: 380px;\n        width: 100%;\n    }\n\n    .contact-wrapper-right input {\n        height: 40px;\n        font-size: 16px;\n        margin-bottom: 12px;\n    }\n\n    .contact-wrapper-right textarea {\n        font-size: 16px;\n        margin-bottom: 20px;\n    }\n\n    .btn#submitBtn {\n        margin-top: 0px;\n        font-size: 16px;\n        font-weight: 400;\n    }\n}\n\n\n@media screen and (max-width: 945px), (max-height: 550px) {\n    .contact-window {\n        padding: 100px 18vw 20px 18vw;\n        margin: 0;\n    }\n\n    .contact-window h1 {\n        font-size: 40px;\n    }\n\n    .contact-window p {\n        font-size: 14px;\n    }\n\n    .contact-wrapper-left {\n        display: none;\n    }\n\n    .contact-wrapper-right {\n        width: 100%;\n        padding: 0;\n    }\n\n    .contact-wrapper-right form {\n        padding-left: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
